import React from 'react';
import { Calendar, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  date: string;
  imageUrl: string;
  category: string;
}

const blogPosts: BlogPost[] = [
  {
    id: '1',
    title: 'Comment rédiger une offre d\'emploi qui attire les meilleurs talents',
    excerpt: 'Découvrez les techniques éprouvées pour créer des offres d\'emploi qui attirent les candidats qualifiés et correspondent à votre culture d\'entreprise.',
    date: '15 juin 2023',
    imageUrl: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    category: 'Recrutement'
  },
  {
    id: '2',
    title: 'Les erreurs à éviter dans vos annonces de recrutement',
    excerpt: 'Les erreurs courantes dans les offres d\'emploi peuvent faire fuir les meilleurs candidats. Voici comment les éviter et optimiser vos annonces.',
    date: '28 juillet 2023',
    imageUrl: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    category: 'Conseils'
  },
  {
    id: '3',
    title: 'L\'IA révolutionne le processus de recrutement',
    excerpt: 'Comment l\'intelligence artificielle transforme le recrutement et permet aux entreprises de trouver plus efficacement les talents dont elles ont besoin.',
    date: '10 septembre 2023',
    imageUrl: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    category: 'Technologie'
  }
];

const BlogSection: React.FC = () => {
  return (
    <section id="blog" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Notre Blog</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Découvrez nos derniers articles, conseils et astuces pour optimiser vos processus de recrutement et attirer les meilleurs talents.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {blogPosts.map(post => (
            <Link 
              key={post.id} 
              to={`/blog/${post.id}`} 
              className="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:scale-105"
            >
              <div className="h-48 overflow-hidden">
                <img 
                  src={post.imageUrl} 
                  alt={post.title} 
                  className="w-full h-full object-cover transition-transform hover:scale-110"
                />
              </div>
              <div className="p-6">
                <div className="flex justify-between items-center mb-3">
                  <span className="text-xs font-medium bg-gradient-primary text-white px-2 py-1 rounded-full">
                    {post.category}
                  </span>
                  <div className="flex items-center text-gray-500 text-xs">
                    <Calendar className="w-3 h-3 mr-1" />
                    <span>{post.date}</span>
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-3 line-clamp-2">
                  {post.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-3">
                  {post.excerpt}
                </p>
                <div className="flex justify-end">
                  <span className="link-gradient text-sm font-medium flex items-center">
                    <span>Lire plus</span>
                    <ArrowRight className="w-4 h-4 ml-1" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        
        <div className="text-center mt-10">
          <Link 
            to="/blog" 
            className="btn-primary inline-block"
          >
            Voir tous les articles
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;